import React from "react"
import { useRouteLoaderData, Form } from "react-router-dom"
import { CurrentOrg } from "../lib/store"
import {
  Box,
  Button,
  Input,
  Heading,
  InputGroup,
  InputRightAddon,
  InputLeftAddon,
  Text,
  Tooltip,
} from "@chakra-ui/react"
import { MdManageAccounts } from "react-icons/md"
import IconEdit from "@/icons/IconEdit"
import IconSave from "@/icons/IconSave"
import { getStripeBillingPortalUrl } from "../lib/stripeBilling"
import { isOrgAdmin as checkIsOrgAdmin } from "../lib/util"

export default function Account() {
  let [editMode, setEditMode] = React.useState("")
  const [currentOrg, setCurrentOrg] = CurrentOrg.useState()
  const user = useRouteLoaderData("auth")

  const isOrgAdmin = React.useMemo(
    () => checkIsOrgAdmin(user, currentOrg),
    [currentOrg, user],
  )

  return (
    <Box mt="8">
      <Heading size="sm">Organization name</Heading>
      {(editMode === "orgname" && (
        <>
          <Form className="columns">
            <InputGroup variant="standardAddon">
              <InputLeftAddon>Organization name: </InputLeftAddon>
              <Input
                name="orgName"
                placeholder={currentOrg.name}
                value={currentOrg.name}
                onChange={setCurrentOrg.name}
                isRequired
              />
              <InputRightAddon>
                <IconSave
                  as="button"
                  type="submit"
                  color="Primary.500"
                  onClick={() => {
                    setEditMode("")
                  }}
                />
              </InputRightAddon>
            </InputGroup>
          </Form>
        </>
      )) || (
        <Box>
          {currentOrg.name}{" "}
          <IconEdit
            as="Button"
            color="Primary.500"
            onClick={() => {
              setEditMode("orgName")
            }}
          />
        </Box>
      )}
      <Heading size="sm">Subdomain (slug)</Heading>
      {(editMode === "slug" && (
        <>
          <Form>
            <InputGroup variant="standardAddon">
              <InputLeftAddon>Subdomain: </InputLeftAddon>
              <Input
                placeholder={currentOrg.slug}
                value={currentOrg.slug}
                onChange={setCurrentOrg.slug}
                isRequired
              />
              <InputRightAddon>
                <Text>.blindinsight.io</Text>
                <IconSave
                  as="button"
                  type="submit"
                  color="Primary.500"
                  onClick={() => {
                    setEditMode("")
                  }}
                />
              </InputRightAddon>
            </InputGroup>
          </Form>
        </>
      )) || (
        <Text color="black">
          {currentOrg.slug}.blindinsight.io{" "}
          <IconEdit
            as="Button"
            color="Primary.500"
            onClick={() => {
              setEditMode("slug")
            }}
          />
        </Text>
      )}
      <Heading size="sm">Subscription Type</Heading>
      <Text color="black">
        <b>
          {currentOrg?.subscription?.active
            ? currentOrg.subscription.display_name
            : "Free"}
        </b>{" "}
        <Tooltip label="Ask your org admin" isDisabled={isOrgAdmin} hasArrow>
          <Button
            as={isOrgAdmin ? "a" : "button"}
            href={
              isOrgAdmin ? getStripeBillingPortalUrl(user.email) : undefined
            }
            target={isOrgAdmin ? "_blank" : undefined}
            rel={isOrgAdmin ? "noreferrer" : undefined}
            variant="secondary"
            size="xs"
            rightIcon={<MdManageAccounts />}
            isDisabled={!isOrgAdmin}
            opacity={isOrgAdmin ? 1 : 0.4}
            cursor={isOrgAdmin ? "pointer" : "not-allowed"}
          >
            Manage
          </Button>
        </Tooltip>
      </Text>
    </Box>
  )
}
